/**
 * Runtime timezone resolution — `App` calls this once and every timestamp in the
 * surface renders in the result (`ChatView`/`ChatStream` pass it through as
 * `timeZone` down to `@4f/ui`'s `formatDateTime`, which does the actual
 * DST-aware offset math). Split out of `App.tsx` (JSX, no bun-test harness in
 * this app) so the resolution + fallback logic is plain-`.ts` and unit-testable.
 */

/**
 * IANA timezone the runtime resolved to. DST-observing zones (`America/New_York`)
 * and non-DST zones (`Asia/Tokyo`, `UTC`) alike resolve to their zone name here —
 * the DST offset itself is applied later, per-timestamp, by `formatDateTime`.
 * Falls back to `'UTC'` only when `Intl` reports nothing (or is unsupported/broken).
 */
export function resolveTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
